// extracted by mini-css-extract-plugin
export var dividerShape1 = "characterPage-module--divider-shape1--3TS_O";
export var slash1 = "characterPage-module--slash1--1psiL";
export var slash2 = "characterPage-module--slash2--1nuGw";